import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const NotScheduledIcon: React.FC<IconProps> = ({
  size = 24,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M25 5L19.2 1M1 5L6.8 1M20.4 22C16.2 26.2 9.4 26.2 5.2 22L20.4 6.8M23.5 14.4C23.5 20.4 18.6 25.3 12.6 25.3C6.6 25.3 1.7 20.4 1.7 14.4C1.7 8.4 6.6 3.5 12.6 3.5C18.6 3.5 23.5 8.4 23.5 14.4Z" stroke={color} strokeWidth="2" strokeLinejoin="round" />
  </Svg>
);

NotScheduledIcon.displayName = 'NotScheduledIcon';
